import { render, staticRenderFns } from "./about-qualifications.vue?vue&type=template&id=64051786&scoped=true&"
import script from "./about-qualifications.vue?vue&type=script&lang=js&"
export * from "./about-qualifications.vue?vue&type=script&lang=js&"
import style0 from "./about-qualifications.vue?vue&type=style&index=0&id=64051786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64051786",
  null
  
)

export default component.exports